var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.235,
    height: 18.751,
    viewBox: "0 0 15.235 18.751",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash",
    transform: "translate(-48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3799",
    "data-name": "Path 3799",
    d: "M61.77,2.344H58.547V1.758A1.76,1.76,0,0,0,56.79,0H54.446a1.76,1.76,0,0,0-1.758,1.758v.586H49.465A1.467,1.467,0,0,0,48,3.809V5.86a.586.586,0,0,0,.586.586h.32l.506,10.631a1.756,1.756,0,0,0,1.756,1.674h8.9a1.756,1.756,0,0,0,1.756-1.674l.506-10.631h.32a.586.586,0,0,0,.586-.586V3.809A1.467,1.467,0,0,0,61.77,2.344ZM53.86,1.758a.587.587,0,0,1,.586-.586H56.79a.587.587,0,0,1,.586.586v.586H53.86ZM49.172,3.809a.293.293,0,0,1,.293-.293H61.77a.293.293,0,0,1,.293.293V5.274H49.172Zm11.48,13.212a.585.585,0,0,1-.585.558h-8.9a.585.585,0,0,1-.585-.558l-.5-10.575H61.156Z",
    fill: "#940d0d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3801",
    "data-name": "Path 3801",
    d: "M320.586,216.79a.586.586,0,0,0,.586-.586v-7.618a.586.586,0,0,0-1.172,0V216.2A.586.586,0,0,0,320.586,216.79Z",
    transform: "translate(-263.039 -200.382)",
    fill: "#940d0d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3802",
    "data-name": "Path 3802",
    d: "M160.586,216.79a.586.586,0,0,0,.586-.586v-7.618a.586.586,0,0,0-1.172,0V216.2A.586.586,0,0,0,160.586,216.79Z",
    transform: "translate(-106.898 -200.382)",
    fill: "#940d0d"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.2484c662.svg";
export { ForwardRef as ReactComponent };